// Hook for PUT /projects/:projectId/settings/dashboard/reports/:reportId

import { axios } from '@/src/lib/axios/axios';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

export type EditDashboardReportUrlPayload = {
  name: string;
  url: string;
};

export type EditDashboardReportUrlResponse = {
  success: boolean;
  message?: string;
};

const editDashboardReportUrl = async (
  projectId: string,
  reportId: string,
  payload: EditDashboardReportUrlPayload
): Promise<EditDashboardReportUrlResponse> => {
  const res = await axios.put(
    `api/projects/${projectId}/settings/dashboard/reports/${reportId}`,
    payload
  );
  return res.data;
};

type UseDashboardReportOptions = {
  config?: UseMutationOptions<EditDashboardReportUrlResponse, Error, EditDashboardReportUrlPayload>;
};

export const useUpdateDashboardReport = (
  projectId: string,
  reportId: string,
  options: UseDashboardReportOptions = {}
) => {
  const mutation = useMutation<
    EditDashboardReportUrlResponse,
    Error,
    EditDashboardReportUrlPayload
  >((payload) => editDashboardReportUrl(projectId, reportId, payload), {
    ...options.config,
  });

  return {
    mutation,
    editDashboardReportUrl: mutation.mutate,
    editDashboardReportUrlAsync: mutation.mutateAsync,
    data: mutation.data,
    error: mutation.error,
    isLoading: mutation.isLoading,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
  };
};
